/* eslint-disable react/no-unstable-nested-components */
// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
import React from "react"
import styled from "styled-components"
// import { theme } from "styles/theme"
// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

type Props = {
    children?: React.ReactNode
    className?: String | null
}

ZPageSectionHelp.defaultProps = {
    children: null,
    className: "",
}

export default function ZPageSectionHelp({ children, className }: Props) {
    return (
        <StyledZPageSectionHelp className={className + ""}>
            <section>{children}</section>
        </StyledZPageSectionHelp>
    )
}

// 〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓	STYLED_COMPONENTS

const StyledZPageSectionHelp = styled.div`
    padding: 10px;
    font-size: 0.9em;
    section {
        background-color: rgb(230, 255, 230);
        border: 1px solid green;
        font-size: 0.8em;
        padding: 5px;
        h2 {
            color: green;
            font-size: 1.3em;
            margin: 0px;
            margin-bottom: 0.6em;
        }
        h3 {
            color: green;
            font-size: 1.2em;
            margin: 0px;
            margin-bottom: 0.4em;
        }
        h4 {
            color: green;
            font-size: 1.1em;
            margin: 0px;
            margin-bottom: 0.2em;
        }
        p {
            padding: 0px;
            padding-left: 0.5em;
            margin: 0px;
        }
        ul {
            margin: 0px;
        }
    }
`
